/* import __COLOCATED_TEMPLATE__ from './sq-dropdown-trigger.hbs'; */
import Component from '@ember/component';

/*
 `sq-dropdown-trigger` is intended to be used in `sq-dropdown`, it should not be used elsewhere.
 */
// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['dropdown__trigger'],
  tagName: 'button',
  classNameBindings: ['isActive:dropdown__trigger--is-active', 'isDisabled:dropdown__trigger--is-disabled'],
  attributeBindings: ['isDisabled:disabled', 'tabindex', 'style', 'type', 'aria-controls', 'aria-expanded', 'aria-label'],
  type: 'button',
  tabindex: 0
});